import React from 'lib/react';
import {
  EVButton,
  makeStyles, EVArrowForwardIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { useState, useEffect } from 'react';
import { encryptAndEncode } from 'utils/app.utils';
import { UPGRADE_ROUTE } from 'constants/RouteConstants';
import { CRYPTO_KEY, CRYPTO_IV } from 'constants/AppConstants';
import { Link } from 'lib/router';

export const useStyles = makeStyles(() => ({
  upgradeBtn: {
    width: '125px',
    padding: '4px 12px 4px 12px',
    '&:hover': { backgroundColor: '#F0F2F7' },
  },
  upgradeBtnLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
  upgradeBtnEsx: {
    minWidth: 'unset',
    padding: '10px 16px',
    textTransform: 'none',
  },
  upgradeBtnEsxLabel: {
    padding: 0,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
  },
  upgradeArrow: {
    transform: 'rotate(-90deg)',
  },
}));
function UpgradeButton({ reportId, upgradeESX = false }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [encryptedReportID, setEncryptedReportID] = useState(null);

  useEffect(() => {
    encryptAndEncode(reportId, CRYPTO_KEY, CRYPTO_IV).then(setEncryptedReportID);
  }, [reportId]);

  return (
    <EVButton
      id={upgradeESX ? `upgradeBtn-files-${reportId}` : `upgradeBtn-${reportId}`}
      variant={upgradeESX ? 'contained' : 'text'}
      color="primary"
      component={Link}
      to={`${UPGRADE_ROUTE}?upgradeReportId=${encryptedReportID}${upgradeESX ? '&upgradeESX=true' : ''}`}
      className={upgradeESX ? classes.upgradeBtnEsx : classes.upgradeBtn}
      classes={{ label: upgradeESX ? classes.upgradeBtnEsxLabel : classes.upgradeBtnLabel }}
      onClick={(e) => e.stopPropagation()}
    >
      {!upgradeESX && <EVArrowForwardIcon className={classes.upgradeArrow} />}
      {t('common_upgrade')}
    </EVButton>
  );
}
UpgradeButton.defaultProps = {
  upgradeESX: false,
};

UpgradeButton.propTypes = {
  reportId: PropTypes.number.isRequired,
  upgradeESX: PropTypes.bool,
};
export default UpgradeButton;
